import { getFunctions, httpsCallable } from "firebase/functions";
import { auth } from "../../firebase";

export const handleStripeConnect = async (setAlert, setIsSaving) => {
  try {
    const user = auth.currentUser;
    if (!user) {
      setAlert({
        show: true,
        type: "error",
        message: "Please sign in first.",
      });
      return;
    }

    setIsSaving(true);
    
    // 🟢 Open a blank tab immediately on click to bypass browser popup blockers
    const stripeWindow = window.open('about:blank', '_blank');

    const functions = getFunctions();
    const createStripeAccount = httpsCallable(functions, "createStripeAccount");

    // 🟢 Call the Firebase Cloud Function
    const res = await createStripeAccount({
      uid: user.uid,
      email: user.email,
    });

    // 🟢 Redirect to Stripe Onboarding or Dashboard
    if (res.data?.url) {
      if (stripeWindow) {
        stripeWindow.location.href = res.data.url;
      } else {
        // Fallback if the browser completely blocked the popup
        window.location.href = res.data.url;
      }
    } else {
      if (stripeWindow) stripeWindow.close();
      setAlert({
        show: true,
        type: "error",
        message: "Stripe returned no onboarding URL. Try again.",
      });
    }
  } catch (error) {
    console.error("Stripe connect error:", error);
    setAlert({
      show: true,
      type: "error",
      message: "Failed to connect to Stripe. Please try again.",
    });
  } finally {
    setIsSaving(false);
  }
};